import { useMemo } from "react"
import { GetApp } from "../../App"
import { Block, BlockFieldInputsDivider, BlockRow } from "../../Components/Block"
import { ICruiseCalculations, INote, INoteType } from "../../Types"
import { TrackView } from "../TrackView"
import { TrackViewData } from "../TrackView/Layer"
import { GetData } from "./Context"
import { PrintCruiseViewProps } from "./Params"
import { PrintCalculationsView } from "./CalculationsView"
import { PrintPlanningNoteView } from "./PlanningNoteView"
import { PrintTripListView } from "./TripListView"

export function PrintCruiseView({ cruise }: PrintCruiseViewProps) {
  const app = GetApp();
  const data = GetData();
  const tc = app.getT("PrintView");

  const tracks = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.tracks.filter((track) => track.cruiseId == cruise.id);
  }, [data]);

  const tripLists = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.trips.filter((trip) => trip.cruiseId == cruise.id).map((trip) => {
      return <PrintTripListView key={trip.id} trip={trip} />;
    });
  }, [data]);

  const planningNotes = useMemo(() => {
    return (cruise.notes || []).filter((note) => note.cruiseId == cruise.id && note.noteType === INoteType.planning).map((note: INote) => {
      return <PrintPlanningNoteView key={note.id} note={note} />;
    });
  }, [cruise]);

  const _calculated = cruise.calculated;

  return (
    <>
      <Block className="PrintCruiseView-block container-boxed">
        <h2>{tc("cruise")}: {cruise.title}</h2>
        <BlockRow className="PrintCruiseView-mainData">
          <h4>
            <span className="print-text-normal">{tc("from_date")}</span> {app.format("date", cruise.startedAt)}
            <span className="print-text-normal print-distance-left">{tc("until_date")}</span> {app.format("date", cruise.completedAt)}
            <span className="print-distance-left"><BlockFieldInputsDivider /></span>
            <span className="print-text-normal print-distance-left">{tc("from_loc")}</span> {(cruise.calculated as ICruiseCalculations)?.startLocation || ""}
            <span className="print-text-normal print-distance-left">{tc("to_loc")}</span> {(cruise.calculated as ICruiseCalculations)?.endLocation || ""}
          </h4>
        </BlockRow>

        <div className="PrintCruiseView-track">
          {TrackViewData.hasPositions(tracks) && <TrackView fullscreen={false} noInteraction={true} tracks={tracks} timezone={app.status?.systemTimezone ?? 0} />}
        </div>

        <div className="PrintCruiseView-statistics container-boxed-inner">
          <h4>{tc("cruise_statistics")}</h4>
          {cruise.calculated && <PrintCalculationsView calculated={cruise.calculated} />}
        </div>
      </Block>

      {planningNotes.length > 0 && (
        <Block className="PrintPlanningView container-boxed">
          <h4>{tc("note_planning")}</h4>
          <Block className="PrintPlanningNotesView">
            {planningNotes}
          </Block>
        </Block>
      )}

      <Block className="PrintTripListView-block container-boxed">
        <h3>{tc("trip_list")}</h3>
        {tripLists}
      </Block>

    </>
  );
}
